
import {Component, Prop, Vue} from "vue-property-decorator";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {ISimilarNumbers} from "@/modules/barriers/interfaces/similar-numbers.interface";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {bus} from "@/plugins/bus";
import {ICarRequest} from "@/modules/Car/interfaces/car-request.interface";
import {httpResource} from "@/resources/http.resource";

  @Component({})
  export default class SimilarActionsCell extends Vue {
    @Prop() cell: IAppTable.ITableProp;
    @Prop() entity: ISimilarNumbers.IEntity;
    @Prop() index: number;

    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }

    async removeNumberRow() {
      let asyncAction = async () => {
        const action = ICarRequest.Action.CarsMK;
        const params: any = {
          command: ICarRequest.Command.RemoveFromHistory,
          carId: this.entity.carId,
          carNumber: this.entity.carNumber,
          corpId: this.entity.corpId,
        };
        const response = await httpResource.httpAction({ action, params });
        this.$notify({
          title: 'Успешно',
          message: `Строка с номером ${this.entity.carNumber} была удалена.`,
          type: 'success'
        });
        bus.$emit(ISimilarNumbers.Event.ReloadSimilarNumbersTable);
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }
  }
